// @flow

import React from 'react';

import Text from 'atomize/dist/atoms/text/Text';

import Link from './Link';

export default function transformHtml(node: Object, index: number) {


  // TODO: remove base URL
  if (node.type === 'tag' && node.name === 'a' && (!node.attribs || !node.attribs.style)) {
    const {children, attribs} = node;
    const {href, ...other} = attribs;
    return <Link {...other} key={href} to={href} rel="noopener noreferrer" target='_blank'>{children && children[0] && children[0].data}</Link>
  }
  // else if (node.type === 'tag' && node.name==='p' && node.children && !node.children.length) {
  //   return <br key={`br-${index}`} />
  // }
  // else if (node.type === 'tag' && node.name==='p') {
  //   const {children} = node;
  //   return (
  //     <Text tag={node.name} key={index} p={{b: '0.5rem'}}>{children && children[0] && children[0].data}</Text>
  //   );
  // }
}
